import axios from "axios";
import { Constants } from "../utils/Constants";

export const login = (email, password) => {
    return axios.post(`${Constants.baseUrl}/auth`, { email, password });
}

export const forgotPassword = (form) => {
    return axios.post(`${Constants.baseUrl}/password/forgot`, form);
}

export const resetPassword = (form) => {
    return axios.post(`${Constants.baseUrl}/password/reset`, form);
}
